// extracted by mini-css-extract-plugin
export default {"skeletonCard":"Skeletons_skeletonCard__IhpQR","skeleton":"Skeletons_skeleton__K9+Zl","shimmer":"Skeletons_shimmer__wKrcC"};